export default {
	init() {
		// JavaScript to be fired on all pages
		$('#openNav').on('click', function(e) {
			e.preventDefault()
			$('.header__nav-primary').fadeIn()
			$('#closeNav').fadeIn()
			$(this).hide()
		})

		$('#closeNav').on('click', function(e) {
			e.preventDefault()
			$('.header__nav-primary').fadeOut()
			$('#openNav').fadeIn()
			$(this).fadeOut()
		})

		$('.header__search-icon').on('click', function() {
			$('.search__container').slideDown()
			$('.header__search-icon svg').hide()
			$('.header__right .close').css('display', 'inline-flex')
			$('.header').css('top', '100px')
		})

		$('.header__right .close').on('click', function() {
			$('.search__container').slideUp()
			$('.header__search-icon svg').show()
			$('.header__right .close').hide()
			$('.header').css('top', '0')
		})

		$('.promotions__slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 4,
			responsive: [{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
						arrows: false,
					},
				},
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			],
		})
		//
		$('.footer__content--col__button').click(function(e) {
        e.preventDefault()
        $('.enquiry-form').fadeIn()
		})

		$('.event-package__btn').on('click', function(e) {
			e.preventDefault()
			if (!$(this).hasClass('wedding')) {
				$('#event-space-package-form').fadeIn()
			} else {
				window.location.replace('https://www.the19th.com.au/events/weddings/')
			}
		})

    setTimeout(() => {
      $(document).on("mouseout", evt => {
          if(evt.toElement === null && evt.relatedTarget === null) {
              $(evt.currentTarget).off("mouseout");
              $('#subscribe-popup-form').fadeIn()
          }
      });
  }, 5000);

		$(document).mouseup(function(e) {
			var enquiry_form = $('.enquiry-form__container')
      var close_btn = $('.enquiry-form__container__close-btn')
			// if the target of the click isn't the container nor a descendant of the container
			if (
				(!enquiry_form.is(e.target) &&
				enquiry_form.has(e.target).length === 0) ||
        close_btn.is(e.target)
			) {
				$('.enquiry-form').fadeOut()
			}
		})

    $('#subscribe-popup').on('click', function() {
        $('.subscribed').toggle()
        $('.no-subscribe').toggle()
    })

		function setHeightStayContent() {
			var content = $('.campaign__promotions .promotions__content')

			var height = []

			$.each(content, function() {
				height.push($(this).height())
			})

			//calc the highest int from height
			var maxHeight = Math.max.apply(Math, height)

			if (maxHeight > 120) {
				content.css('height', maxHeight + 8)
			} else {
				content.css('height', '120px')
			}
		}

		setHeightStayContent()

		//videos

		function playVideo() {
			var vid = $('#campaign__video')[0]
			vid.play()
		}

		var vid = $('#campaign__video')
		var content = $('.campaign-last__content')
		var container = $('.campaign-last__image')
		var row = $('.campaign-last__row')

		$('.play').on('click', function(e) {
			e.preventDefault()
			$(this).hide()
			vid.fadeIn()
			setTimeout(playVideo(), 2000)
			content.hide()
			container.css({
				'z-index': 99999,
				'width': '100%',
			})
			row.css({
				'height': 'unset',
			})
		})

		$('#campaign__video').on('ended', function() {
			vid.fadeOut()
			$('.play').show()
			container.css({
				'z-index': 0,
				'width': '60%',
			})
			row.css({
				'height': '400px',
			})
			content.fadeIn()
		})

		//campaign resize
		$(window).resize(function() {
			if ($(window).width() <= 1000) {
				$('.featured__container').slick({
					dots: false,
					arrows: true,
					slidesToShow: 4,
					responsive: [{
							breakpoint: 1024,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 3,
							},
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2,
							},
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								infinite: true,
							},
						},
						// You can unslick at a given breakpoint now by adding:
						// settings: "unslick"
						// instead of a settings object
					],
				})
			}

			if ($(window).width() <= 480) {
				var content = $('.campaign__promotions .promotions__content')
				content.css('height', 'auto')
			}
		})

		if ($(window).width() <= 1000) {
			$('.featured__container').slick({
				dots: false,
				arrows: true,
				slidesToShow: 1,
				responsive: [{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						},
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
						},
					},
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				],
			})
		}

		if ($(window).width() <= 480) {
			var promo_content = $('.campaign__promotions .promotions__content')
			promo_content.css('height', 'auto')
		}
	},

	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js